import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  SmartAlert,
  SmartFormInterFace,
  SmartLoaderInterface,
  SmartTable,
  SmartTableNewInterface,
} from "soft_digi";
import { SdsFsDownloadFile } from "soft_digi/dist/services/FileService";
import { SESSION_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { checkInterSection } from "../../services/core/FilterService";
import { showAlertAutoClose } from "../../services/notifyService";
import { post } from "../../services/smartApiService";
import ChangeDateForm from "../Home/ChangeDateForm";
import SessionForm from "./SessionForm";
import TraineeReport from "./TraineeReport";
import ExcelJS from "exceljs";
import PdfViewer from "../../components/PdfViewer";
// import ChangeDateForm from "./ChangeDateForm";

interface HeaderProps {
  mode: string;
}

const GetTraineeList = () => {
  const { openModal, closeModal, user, setTitle } = useSiteContext();
  const navigate = useNavigate();
  const [tabData, setTabData] = useState([]);
  const is_admin = checkInterSection(user?.roles || [], ["ADMIN", "AGENCY"]);

  const loadTableData = () => {
    let URL = SESSION_URLS.GET_TRAINEE;
    // let data_in = {
    //   status: mode,
    // };
    const subscription = post(URL, {}).subscribe((response) => {
      setTabData(response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {
    loadTableData();
    setTitle("Total Loco Pilots Assessed");
  }, []);

  const CancelData = (id: any) => {
    const subscription = post(SESSION_URLS.CANCEL_SESSION, {
      id: id,
    }).subscribe((response) => {
      showAlertAutoClose("Cancel Successfully...", "success");
      closeModal();
      loadTableData();
      // setLoading(false);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const openCancelModal = (id: any) => {
    let alertProps: SmartLoaderInterface.SmartAlertInterface = {
      title: (
        <span className="has-text-danger">
          <i className="fa fa-check"></i> Session Cancel!
        </span>
      ),
      alertFunction: (option) => {
        if (option === "yes") {
          CancelData(id);
          SmartAlert.hide();
        }
      },
      content: (
        <p>
          Note: Do you wish to Cancel this Session? This action cannot be
          reverted
        </p>
      ),
      className: "custom-alert",
    };

    SmartAlert.show(alertProps);
  };

  // const viewEditForm = (data:any) => {
  //  // const selectedData = staticTabData.find((data) => data.ID === id);

  //  openChangeForm(data);
  // };
  const viewEditForm = (id: any) => {
    let options = {
      title: "Loco Pilot Report",
      content: <TraineeReport id={id} />,
      className: "sd-efl-modal",
      closeBody: false,
      width: 80,
    };
    openModal(options);
  };
  const openOfficesForm = (data: any) => {
    let options = {
      title: <>{data.ID ? "Session Update Form" : "Session Form"}</>,
      content: <SessionForm dataIn={data} loadTableData={loadTableData} />,
      className: "sd-efl-modal",
      closeBody: false,
      width: 60,
    };
    openModal(options);
  };
  const openChangeForm = (data: any) => {
    let options = {
      title: <>{data.ID ? "Change Date Form" : "Change Date Form"}</>,
      content: <ChangeDateForm dataIn={data} loadTableData={loadTableData} />,
      className: "sd-efl-modal sd-exam-modal-one",
      closeBody: false,
      width: 60,
    };
    openModal(options);
  };

  const onSubmit = (dt: any) => {
    let url = SESSION_URLS.GET_TRAINEE_PDF;
    //console.log("id", dt, "url = ", url);
    const subscription = post(url, { session_user_id: dt["ID"] }).subscribe(
      (response) => {
        SdsFsDownloadFile(response.data.content, "Loco Pilot Report.pdf");
      }
    );

    return () => {
      subscription.unsubscribe();
    };
  };

  const buttons = [
    {
      label: "",
      type: "icon",
      leftIcon: "fa fa-eye",
      classList: ["smart-hims-table-view-icon"],
      onClick: (data: any) => {
        viewEditForm(data["ID"]);
      },
      hideFunction: (d: any) => d?.status !== "completed",
    },
    {
      label: "",
      type: "icon",
      leftIcon: "fa fa-download",
      classList: ["smart-hims-table-delete-icon"],
      onClick: (data: any) => onSubmit(data),
      hideFunction: (data: any) => {
        return data["status"] == "completed" ? false : true;
      },
    },
  ];

  // const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
  //   { title: "S.NO", index: "s_no", type: "sno", width: "5" },
  //   { title: "Employee ID", index: "euserid" },
  //   { title: "Name", index: "ename" },
  //   { title: "Mobile Number", index: "mobile_no" },
  //   { title: "Loco -shed", index: "roles" },
  //   {
  //     title: "Action",
  //     index: "action",
  //     type: "buttons",
  //     buttons: buttons,
  //     width: "10",
  //   },
  // ];

  const statusTags = [
    { value: "started", label: "Started", class: "is-info" },
    { value: "active", label: "Active", class: "is-primary" },
    { value: "cancel", label: "Cancel", class: "is-danger" },
    { value: "completed", label: "Completed", class: "is-primary" },
  ];
  const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "5" },
     {
      title: "Agency Name",
      index: "agency_name",
    },
    {
      title: "Project",
      index: "project_name",
    },
     {
      title: "Session ID",
      index: "session_label",
    },
     {
      title: "Name",
      index: "ename",
    },
   
    {
      title: "Employee ID",
      index: "euserid",
    },
   

   
    {
      title: "Mobile No",
      index: "mobile_no",
    },

    {
      title: "Score (%)",
      index: "total_score",
    },
    //     {
    //   title: "Venue",
    //   index: "location",
    // },

    // {
    //   title: "Pass (or) Fail",
    //   index: "pass_status",
    //   valueFunction: (data) => {
    //     return data["status"] == "completed" ? data["pass_status"] : "";
    //   },
    // },
    // {
    //   title: "status",
    //   index: "status",
    // },

    {
      title: "Action",
      index: "action",
      type: "buttons",
      buttons: buttons,
      width: "10",
    },
  ];
  const exportexl = async (dataToExport: any[]) => {
    const title = "Total Loco Pilots Assessed";
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(title);

    const headers = [
      "S.NO",
      "Project",
      "Session ID",
      "Employee ID",
      "Name",
      "Mobile No",
      "Score (%)",
    ];

    worksheet.mergeCells(`A1:F1`);
    const titleCell = worksheet.getCell("A1");
    titleCell.value = "Total Loco Pilots Assessed";
    titleCell.font = { bold: true, size: 16, color: { argb: "FFFFFF" } };
    titleCell.alignment = { horizontal: "center", vertical: "middle" };
    titleCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "4472C4" },
    };

    worksheet.addRow(headers);
    const headerRow = worksheet.getRow(2);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "D9E1F2" },
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    dataToExport.forEach((item, index) => {
      const row = [
        index + 1,
        item.project_name || "",
        item.session_label || "",
        item.euserid || "",
        item.ename || "",
        item.mobile_no || "",
        item.total_score || "",
      ];

      const addedRow = worksheet.addRow(row);
      addedRow.eachCell((cell) => {
        cell.alignment = { vertical: "middle", wrapText: true };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
    });

    worksheet.columns.forEach((col) => {
      col.width = 20;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "LocoPilotExport.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-4",
      custom: <p className="is-size-4 has-text-weight-bold"></p>,
    },
    {
      type: "SEARCH",
      widthClass: "is-4",
      align: "JUSTIFY",
    },

    {
      type: "BUTTONS",
      widthClass: "is-2",
      align: "CENTER",
      buttons: [
        {
          type: "FILTER",
          className: "",
        },
        // {
        //   type: "EXPORT",
        //   className: "smart-third-button",
        // },
      ],
    },
    {
      type: "CUSTOM",
      widthClass: "is-2",
      align: "CENTER",
      custom: (
        <div className="is-size-4">
          <span
            className="icon is-clickable excel-refresh-icon mx-3"
            onClick={loadTableData}
          >
            <i className="fa fa-refresh"></i>
          </span>

          <span
            className="icon ml-4 mx-3 is-clickable excel-export-icon"
            onClick={() => exportexl(tabData)}
            data-tooltip-id="export-tooltip"
            data-tooltip-content="Export"
          >
            <i className="fa fa-upload"></i>
          </span>
        </div>
      ),
    },
  ];
  const filterFields: SmartFormInterFace.SmartFormElementProps[] = [
    // {
    //   type: "TEXT_BOX",
    //   width: "12",
    //   name: "project_name",
    //   class_name: "is-small",
    //   element: {
    //     label: "Project",    size: "small",
    //   },
    // },
    {
      type: "SELECT_BOX",
      width: "12",
      name: "project_name",
      class_name: "is-small",
      element: {
        label: "Project Name",
        size: "small",
        options: [
          { value: "WR", label: "WR" },
          { value: "NCR", label: "NCR" },
          { value: "WCR", label: "WCR" },
          { value: "SCR", label: "SCR" },
          { value: "ER", label: "ER" },
        ],
      },
    },
  ];

  return (
    <div className="sd-efl-input">
      <SmartTable
        columns={columns}
        data={tabData}
        tableTop={tableTop}
        filterFields={filterFields}
        tableProps={{
          className: "is-hoverable is-bordered smart-hims-table",
          isResponsive: true,
          searchPlaceHolder: "Search",
        }}
        paginationProps={{
          pageSize: 10,
        }}
      />
    </div>
  );
};

export default GetTraineeList;
